export const enum LocationSelectionType {
  RegisteredLocation,
  ManualLocation,
}
